export default __webpack_public_path__ + "static/media/features_on_street_parking.e8f62bd2.png";